<template>
    <div style="width: 100%;">
        <patternlib-textinput 
            :label="$t('newPassword.newPassword')" 
            type="password"
            ref="password"
            style="margin-top: var(--spacing-7);"
            @lhChange="(ev) => {validate(ev.detail.value)}"
            @click="validate(protoPass)"
            :status="showPasswordReq ? 'error': (password ? 'success': 'default')"
        />
        <div v-if="showPasswordReq">
            <patternlib-alert-message 
                :type="getAlertType(useLowercase)"
                show-icon=true
            >
                {{ $t("newPassword.oneLowercase") }}
            </patternlib-alert-message>

            <patternlib-alert-message 
                :type="getAlertType(useUppercase)"
                show-icon=true
            >
                {{ $t("newPassword.oneUppercase") }}
            </patternlib-alert-message>

            <patternlib-alert-message 
                :type="getAlertType(useSpecialOrDigitChar)"
                show-icon=true
            >
                {{ $t("newPassword.digitOrSpecialChar") }}
            </patternlib-alert-message>

            <patternlib-alert-message 
                :type="getAlertType(hasEightChar)"
                show-icon=true
            >
                {{ $t("newPassword.minEightChars") }}
            </patternlib-alert-message>

            <patternlib-alert-message 
                :type="getAlertType(noFirstOrLastname)"
                show-icon=true
            >
                {{ $t("newPassword.noNames") }}
            </patternlib-alert-message>

            <patternlib-alert-message 
                :type="getAlertType(noPartsOfMail)"
                show-icon=true
            >
                {{ $t("newPassword.noPartsOfMail") }}
            </patternlib-alert-message>
        </div>
        <patternlib-textinput 
            :label="$t('newPassword.newPasswordRepeat')" 
            :error-text="$t('newPassword.unequalPasswords')"
            :status="(password && passwordRepeat) ? ((passwordRepeat == password) ? 'success' : 'error') : 'default'"
            type="password"
            ref="passwordRepeat"
            style="display: block; margin-top: 16px;"
            @lhChange="(ev) => {passwordRepeat = ev.detail.value}"
        />
    </div>
</template>

<script>
export default {
    data: () => ({
        firstname: "",
        lastname: "",
        email: "",

        password: null,
        passwordRepeat: null,
        protoPass: null,

        useLowercase: false,
        useUppercase: false,
        useSpecialOrDigitChar: false,
        hasEightChar: false,
        noFirstOrLastname: false,
        noPartsOfMail: false,

        showPasswordReq: false
    }),

    components: {
    },

    methods: {
        validate(value) {
            this.protoPass = value
            // Uses Validation technique from LIS described in https://hops.liebherr.com/browse/HRMIT-45478
            if (this.protoPass == null) {
                this.password = null
                return
            }

            function getTokens(input){
                if (!input?.trim()) return [];

                // We use the same delimiters as Microsoft is using for complexity requirements, mentioned in:
                // https://learn.microsoft.com/en-us/windows/security/threat-protection/security-policy-settings/password-must-meet-complexity-requirements
                const delimiters = /[,.\-–_ #\t]/;

                return input
                .split(delimiters)
                .filter((t) => t.trim().length > 2)
                .map((t) => t.toLowerCase());
            }

            this.useLowercase = /[a-z]/.test(this.protoPass)
            this.useUppercase = /[A-Z]/.test(this.protoPass)
            this.useSpecialOrDigitChar = /[0-9]|!|@|#|\$|\+|=/.test(this.protoPass)
            this.hasEightChar = (this.protoPass.length >= 8)
            this.noFirstOrLastname = !getTokens(`${this.firstname} ${this.lastname}`).some((token) => this.protoPass.toLowerCase().includes(token.toLowerCase()))
            this.noPartsOfMail = !getTokens(this.email).some((token) => this.protoPass.toLowerCase().includes(token.toLowerCase()))
            if (this.useLowercase && 
                this.useUppercase &&
                this.useSpecialOrDigitChar &&
                this.hasEightChar &&
                this.noFirstOrLastname &&
                this.noPartsOfMail) {
                    this.password = this.protoPass
                    this.showPasswordReq = false
                    return
                }
            this.password = null
            this.showPasswordReq = true
        },

        getPassword(firstname, lastname, email) {
            this.firstname = firstname
            this.lastname = lastname
            this.email = email
            this.validate(this.$refs.password.value)
            this.showPasswordReq = false
            if (!this.password) {
                this.showPasswordReq = true
                return null
            }

            if (this.password != this.$refs.passwordRepeat.value) {
                return null
            }

            return this.password
        },

        clearFields() {
            this.$refs.password.value = ""
            this.$refs.passwordRepeat.value = ""
        },

        getAlertType(fulfilled) {return fulfilled ? "success" : "error"}
    }
}
</script>

<style lang="scss" scoped>
patternlib-alert-message {
    margin-top: 8px;
}
</style>